import $ from 'jquery'

if (document.getElementById('lamp-anim')) {
      window.lavaAnimation.run();
    }
    setTimeout(function() {
      $('.js-works-d-list').addClass('is-loaded');
    }, 150);